export const transferParams = () => {
  const params = new URLSearchParams(document.location.search.substring(1))
  const navigation = params.get('navigation')
  if (navigation != null) {
    return `?navigation=${navigation}`
  }
  return ''
}
